var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlues(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43706_112793)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 6.125H1.3125C0.8295 6.125 0.4375 6.517 0.4375 7C0.4375 7.483 0.8295 7.875 1.3125 7.875H6.125V12.6875C6.125 13.1705 6.517 13.5625 7 13.5625C7.483 13.5625 7.875 13.1705 7.875 12.6875V7.875H12.6875C13.1705 7.875 13.5625 7.483 13.5625 7C13.5625 6.517 13.1705 6.125 12.6875 6.125H7.875V1.3125C7.875 0.8295 7.483 0.4375 7 0.4375C6.517 0.4375 6.125 0.8295 6.125 1.3125V6.125Z",
    fill: "#current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43706_112793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlues);
export default __webpack_public_path__ + "static/media/Plues.f6e09760e35d4d830da11e223debd8d4.svg";
export { ForwardRef as ReactComponent };